import React, { useEffect, useState } from "react";
import DataGrid, { Column, Editing, Lookup, Popup, Form, Item,ColumnFixing,Pager,Paging,SearchPanel } from "devextreme-react/data-grid";
import axios from "axios";
import Swal from "sweetalert2";
import { Modal, Button } from "react-bootstrap";
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import {API_BASE_URL} from '../../../../config';

const BuildingsGrid = ({ propertyId }) => {
  const [buildings, setBuildings] = useState([]);
  const [infoDetail, setDetail] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [suites, setSuites] = useState([]);
  const modClose = () => setModalShow(false);

  const handleRowClick = async (e) => {
    
    setDetail(e.data);
    setModalShow(true);
    
    try {
      const res = await axios.get(`${API_BASE_URL}api/buildingsuites/${e.data.buildingid}`);
      setSuites(res.data);
    } catch (err) {
      console.error("Error fetching suites:", err);
      setSuites([]);
    }
  };

  const optionKey = [
    { ID: "*", Name: "County Owned", value: "County Owned - *" },
    { ID: "^", Name: "County Maintained", value: "County Maintained - ^" },
    { ID: "LM", Name: "Leased Property - Maintained by County", value: "Leased Property - Maintained by County - LM" },
    { ID: "LN", Name: "Leased Property Non-maintained", value: "Leased Property Non-maintained – LN" },
    { ID: "0", Name: "Zero Maintenance Responsibility", value: "Zero Maintenance Responsibility – 0" },
    { ID: "CS", Name: "Custodial Stewardship", value: "Custodial Stewardship - CS" },
  ];

  const onSuiteInserted = async (e) => {
    try {
      await axios.put(`${API_BASE_URL}api/suiteadd`, { ...e.data, buildingid: infoDetail.buildingid });
      fetchSuites(infoDetail.buildingid);
    } catch (err) {
      console.error("Error adding suite:", err);
    }
  };

  const onSuiteUpdated = async (e) => {
    try {
      await axios.put(`${API_BASE_URL}api/suiteupdate`, e.data);
      fetchSuites(infoDetail.buildingid);
    } catch (err) {
      console.error("Error updating suite:", err);
    }
  };

  const onSuiteRemoved = async (e) => {
    try {
      await axios.put(`${API_BASE_URL}api/suitedelete`, { suiteid: e.data.suiteid });
      fetchSuites(infoDetail.buildingid);
    } catch (err) {
      console.error("Error deleting suite:", err);
    }
  };

  const fetchSuites = async (buildingId) => {
    try {
      const res = await axios.get(`${API_BASE_URL}api/buildingsuites/${buildingId}`);
      setSuites(res.data);
    } catch (err) {
      console.error("Error fetching suites:", err);
    }
  };

  const fetchBuildings = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}api/propertybuilding/${propertyId}`);
      setBuildings(res.data);
    } catch (err) {
      console.error("Error fetching buildings:", err);
    }
  };

  const onRowInserted = async (e) => {
    try {
      await axios.put(`${API_BASE_URL}api/buildingadd`, { ...e.data, propertyid: propertyId });
      Swal.fire("Done", "Building Added Successfully!", "success");
      fetchBuildings();
    } catch (err) {
      console.error("Error adding building:", err);
    }
  };

  const onRowUpdated = async (e) => {
    try {
      await axios.put(`${API_BASE_URL}api/buildinggrid`, e.data);
      Swal.fire("Updated", "Building Updated Successfully!", "success");
      fetchBuildings();
    } catch (err) {
      console.error("Error updating building:", err);
    }
  };

  const onRowRemoved = async (e) => {
    try {
      await axios.put(`${API_BASE_URL}api/builddel`, { buildingid: e.data.buildingid });
      Swal.fire("Deleted", "Building Deleted Successfully!", "success");
      fetchBuildings();
    } catch (err) {
      console.error("Error deleting building:", err);
    }
  };
  
    const optionYesNo = [{
        ID: 'Y',
        Name: 'Yes',
      }, {
        ID: 'N',
        Name: 'No',
      }]

  useEffect(() => {
    if (propertyId) fetchBuildings();
  }, [propertyId]);

  return (
    <>
      <DataGrid
        dataSource={buildings}
        keyExpr="buildingid"
        className={'dx-card wide-card'}
        showBorders={true}
        columnAutoWidth={true}
        onRowClick={handleRowClick} 
        onRowInserted={onRowInserted}
        onRowUpdated={onRowUpdated}
        onRowRemoved={onRowRemoved}
        
          allowColumnReordering={true}
          rowAlternationEnabled={true}
      >
        {/* Editing Popup Config */}
        <Editing
          mode="popup"
          allowAdding={true}
          allowUpdating={true}
          allowDeleting={true}
        >
          
          <Popup title="Building Details" showTitle={true} width={800} height={600} />
          <Form colCount={2}>
            <Item dataField="bid" />
            <Item dataField="pkey" />
            <Item dataField="buildinglocation" />
            <Item dataField="ownership" />
            <Item dataField="buildingsf" />
            <Item dataField="buildingacres" />
            <Item dataField="disposeflag" />            
            <Item dataField="disposeddate" />
          </Form>
        </Editing>
        <ColumnFixing enabled={true} />
          <Paging defaultPageSize={25} />
          <Pager showPageSizeSelector={true} showInfo={true} allowedPageSizes={[5, 10, 25, 50, 100, 'all']} />
          {/* <Export enabled={true} formats={exportFormats} /> */}
          <SearchPanel visible={true} highlightCaseSensitive={true} />  

        {/* Editable Columns */}
        <Column
          dataField="bid"
          caption="Building ID/L#" width={150}
          cellRender={(data) => {
                    return(<>
                    <div>{(data.data.rand == 1 ?
                    <b style={{color:"#C42929"}}>{data.value}</b>:                  
                    <div >{data.value}</div>
                    )}</div></>)
                }} 
          validationRules={[{ type: "required", message: "Building ID is required" }]}
        />
        <Column dataField="pkey" caption="Key" width={80} cellRender={(data)=>{ return (<>{data.value}</>)}}>
          <Lookup dataSource={optionKey} valueExpr="ID" displayExpr="value" />
        </Column>

        {/* Read-only calculated column */}
        <Column 
          dataField="pkey"
          caption="Key Description" width={200}
          allowEditing={false}
          formItem={{ visible: false }}>
          <Lookup dataSource={optionKey} valueExpr="ID" displayExpr="Name" />
        </Column>

        <Column dataField="buildinglocation" caption="Building Location" width={280}
          cellRender={(cellData) => (
              <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
              {cellData.value}
              </div>
          )}
        />
        <Column dataField="ownership" caption="Ownership" width={200}
          cellRender={(cellData) => (
              <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
              {cellData.value}
              </div>
          )}
        />
        <Column dataField="buildingsf" caption="Building Sq Ft" dataType="number" width={150} />
        <Column dataField="buildingacres" caption="Building Acres" dataType="number" width={150} />        
        <Column dataField={'disposeflag'} caption={'Disposed'} >
            <Lookup dataSource={optionYesNo} valueExpr="ID" displayExpr="Name" />
        </Column>
        <Column dataField={'disposeddate'} caption={'Disposed Date'} dataType={'date'} format={'MM/dd/yyyy'}  />
      </DataGrid>
      <Modal
                  size="lg"
                  show={modalShow} onHide={modClose}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  >
                  <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title-vcenter">
                      Building Details
                      </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                  <div style={{width:'100%'}}>
                      <Box sx={{ flexGrow: 1 }}>
                      <Grid container spacing={2}>
                                      
      
                                  <Grid item xs={12} md={12}>
                                      <div>
                                          <div className='info-title'>Building Information</div>
                                          <div className='info-details'>
                                          <Grid container spacing={2}> 
                                                  <Grid item xs={12} md={3}>
                                                      <div className='info-record-label'>Building ID/L#</div>
                                                      <div className='info-record-value'>{infoDetail.bid}</div>
                                                  </Grid>
                                                  <Grid item xs={12} md={3}>
                                                      <div className='info-record-label'>Key</div>
                                                      <div className='info-record-value'>{infoDetail.pkey}</div>
                                                  </Grid>                                            
                                                  
                                                  <Grid item xs={12} md={3}>
                                                      <div className='info-record-label'>Key Description</div>
                                                      <div className='info-record-value'>
                                                          {
                                                          optionKey.find(opt => opt.ID === infoDetail.pkey)?.Name || ""
                                                          }
                                                      </div>
                                                  </Grid>
                                                  
                                                  <Grid item xs={12} md={3}>
                                                      <div className='info-record-label'>infoDetail Location</div>
                                                      <div className='info-record-value'>{infoDetail.buildinglocation}</div>
                                                  </Grid>
                                                  <Grid item xs={12} md={3}>
                                                      <div className='info-record-label'>Ownership</div>
                                                      <div className='info-record-value'>{infoDetail.ownership}</div>
                                                  </Grid>
                                                  <Grid item xs={12} md={3}>
                                                      <div className='info-record-label'>Building Sq Ft</div>
                                                      <div className='info-record-value'>{infoDetail.buildingsf}</div>
                                                  </Grid>
                                                  <Grid item xs={12} md={3}>
                                                      <div className='info-record-label'>Building Acres</div>
                                                      <div className='info-record-value'>{infoDetail.buildingacres}</div>
                                                  </Grid>
      
                                              </Grid>
                                              
                                          </div>
                                      </div>
                                  </Grid>
                                      <Grid item xs={12} md={12} id="suite-section">
                                          <div>
                                              {/* <div className='info-title'>Suites</div> */}
                                              <div className='info-details'>
                                                <DataGrid
                                                  dataSource={suites}
                                                  keyExpr="suiteid"
                                                  showBorders={true}
                                                  columnAutoWidth={true}
                                                  allowColumnReordering={true}
                                                  rowAlternationEnabled={true}
                                                  onRowInserted={onSuiteInserted}
                                                  onRowUpdated={onSuiteUpdated}
                                                  onRowRemoved={onSuiteRemoved}
                                                >
                                                  <Editing
                                                    mode="row"
                                                    allowAdding={true}
                                                    allowUpdating={true}
                                                    allowDeleting={true}
                                                  />
                                                  
                                                  <Column
                                                    dataField="suitenumber"
                                                    caption="Suite No"
                                                    width={150}
                                                    validationRules={[{ type: "required", message: "Suite No is required" }]}
                                                  />
                                                </DataGrid>

                                              
                                              </div>
                                          </div>
                                      </Grid>
      
                                  </Grid>
                      </Box>
                  </div>
                  </Modal.Body>
                  <Modal.Footer>
                      <Button onClick={modClose}>Close</Button>
                  </Modal.Footer>
          </Modal>

    </>
  );
};

export default BuildingsGrid;
